import React from 'react';
export var BinInformation = function (_a) {
    var name = _a.name, bin = _a.bin, image = _a.image, notes = _a.notes;
    return (React.createElement(React.Fragment, null,
        React.createElement("h2", null, name),
        React.createElement("img", { src: image, height: 300, width: 'auto', alt: notes }),
        bin !== 'Cannot throw in community' && React.createElement("h3", null,
            "Your Bin: ",
            bin),
        bin === 'Cannot throw in community' && React.createElement("h3", null, bin)));
};
